:host {
  display: block;
}

.vs-skeleton {
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.06) 25%, rgba(0, 0, 0, 0.15) 37%, rgba(0, 0, 0, 0.06) 63%);
  background-size: 400% 100%;
  animation-name: skeleton-loading;
  animation-duration: 1.4s;
  animation-timing-function: ease;
  animation-iteration-count: infinite;
  height: 18px;
  border-radius: 5px;
}
.vs-title-skeleton {
  width: 50%;
  height:30px
}

.vs-skeleton-image-placeholder {
  background: #dedede;
  width:100%;
  height:500px;
}

.vs-skeleton-mobile-image-placeholder {
  background: #dedede;
  width:100%;
  height:100px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
